(() => {
  const componentSelector = '[data-product-discovery]';
  const bridgeMarker = 'lcProductDiscoveryBridgeInitialized';

  if (document.currentScript) {
    document.currentScript.dataset.lcProductDiscoveryReady = 'true';
  }

  const getPayload = card => ({
    source_product_id: card.dataset.sourceProductId,
    target_product_id: card.dataset.targetProductId,
    relationship_type: card.dataset.relationshipType,
    relationship_priority: Number(card.dataset.relationshipPriority),
    source_lane: card.dataset.sourceLane,
    placement: card.dataset.placement,
    component_location: card.dataset.componentLocation,
    experiment_cohort_version: card.dataset.cohortVersion
  });

  const getQaContext = () => {
    const previewData = document.querySelector('#OnlineStorePreviewBarNextData');
    if (!previewData) return { qa_traffic: false, qa_theme_id: null };

    try {
      const theme = JSON.parse(previewData.textContent || '{}').theme;

      return {
        qa_traffic: theme?.isDraft === true,
        qa_theme_id: theme?.id ? String(theme.id) : null
      };
    } catch (_error) {
      return { qa_traffic: false, qa_theme_id: null };
    }
  };

  const publish = (eventName, payload) => {
    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function') return;

    try {
      Promise.resolve(analytics.publish(eventName, {
        ...payload,
        ...getQaContext()
      })).catch(() => {});
    } catch (_error) {
      // Customer Events must never interrupt the DOM event or navigation.
    }
  };

  const emit = (card, eventName) => {
    const payload = getPayload(card);

    card.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: payload
    }));

    publish(eventName, payload);
  };

  const initialize = component => {
    if (component.dataset.productDiscoveryInitialized === 'true') return;

    component.dataset.productDiscoveryInitialized = 'true';
    const cards = [...component.querySelectorAll('[data-product-discovery-card]')];

    component.addEventListener('click', event => {
      const link = event.target.closest('[data-product-discovery-cta]');
      if (!link) return;

      const card = link.closest('[data-product-discovery-card]');
      if (card) emit(card, 'product_discovery_click');
    });

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries, activeObserver) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;

        emit(entry.target, 'product_discovery_impression');
        activeObserver.unobserve(entry.target);
      });
    }, { threshold: [0.5] });

    cards.forEach(card => observer.observe(card));
  };

  document.querySelectorAll(componentSelector).forEach(initialize);

  if (document.documentElement.dataset[bridgeMarker] === 'true') return;

  document.documentElement.dataset[bridgeMarker] = 'true';

  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll(componentSelector).forEach(initialize);
  });

  document.addEventListener('lc:product-discovery:load', event => {
    if (event.target.matches?.(componentSelector)) {
      initialize(event.target);
    }

    event.target.querySelectorAll?.(componentSelector).forEach(initialize);
  });
})();
